import React, { useMemo } from 'react';

import { Typography } from '@lyearn/ui';
import SurveyBlockContainer from '@/modules/corporate/modules/survey/views/SurveyEditor/components/SurveyBlockContainer';

import { BlockContainerProps } from '../types';

const BlockContainer: React.FC<BlockContainerProps> = (props) => {
  const { isSelected, onSelect, error, viewMode, children } = props;

  const classes = useMemo(
    () => ({
      focus: {
        focusIndicator:
          viewMode === 'create' ? 'bg-interactive-primary' : 'bg-interactive-secondary-hover',
      },
    }),
    [viewMode],
  );

  return (
    <>
      <SurveyBlockContainer classes={classes} isSelected={isSelected} onSelect={onSelect}>
        {children}
      </SurveyBlockContainer>
      {error ? (
        <Typography className="m-8 mt-4" color="text-text-error" variant="body-short-02">
          {error.message}
        </Typography>
      ) : null}
    </>
  );
};

export default React.memo(BlockContainer);
